import React from "react";

import { cx } from "class-variance-authority";

import * as theme from "./PaginationContent.css";

export function PaginationContent({
    className,
    ...props
}: React.ComponentProps<"ul">) {
    return (
        <ul
            data-slot="pagination-content"
            className={cx(theme.content, className)}
            {...props}
        />
    );
}
